/* ---
	Quick Buy cart helpers (shared by the product card add button and the variant popup)
--- */

if ( typeof window.KROWN_QUICK_BUY === 'undefined' ) {

	window.KROWN_QUICK_BUY = {

		CART_CHANGED_EVENT: 'quick-buy:cart-changed',

		_cartPromise: null,
		_cartFetchedAt: 0,

		/* cart.js, shared between all quick buy elements so a page full of cards only triggers one request */
		getCart(){
			if ( ! this._cartPromise || ( Date.now() - this._cartFetchedAt ) > 1000 ) {
				this._cartFetchedAt = Date.now();
				this._cartPromise = fetch(`${KROWN.settings.routes.cart_url}.js`, { headers: { 'Accept': 'application/json' } })
					.then(response => response.json());
				this._cartPromise.catch(()=>{
					this._cartPromise = null;
				});
			}
			return this._cartPromise;
		},

		invalidate(){
			this._cartPromise = null;
		},

		/* force one shared re-read, even when several elements ask for it within the same event */
		refresh(){
			if ( ! this._refreshing ) {
				this._refreshing = true;
				this.invalidate();
				this._refreshPromise = this.getCart();
				this._refreshPromise.finally(()=>{
					this._refreshing = false;
				});
			}
			return this._refreshPromise;
		},

		/* let every quick buy element re-read the cart after a change */
		notify(){
			this.invalidate();
			document.dispatchEvent(new CustomEvent(this.CART_CHANGED_EVENT));
		},

		lineQuantity(cart, variantId){
			const line = cart.items.find(line=> line.variant_id === parseInt(variantId));
			return line ? line.quantity : 0;
		},

		addVariant(variantId, quantity){
			return fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body: JSON.stringify({ id: parseInt(variantId), quantity })
				})
				.then(response => response.json())
				.then(data=>{
					if ( data.status ) throw data;
					return this.refreshCartFragments();
				})
				.then(()=>{
					this.notify();
				});
		},

		changeVariant(variantId, quantity){
			this.invalidate();
			return this.getCart()
				.then(cart=>{

					const lineIndex = cart.items.findIndex(line=> line.variant_id === parseInt(variantId));

					if ( lineIndex === -1 ) {
						if ( quantity <= 0 ) return { alreadyRemoved: true };
						throw { message: KROWN.settings.locales.cart_general_error };
					}

					return fetch(`${KROWN.settings.routes.cart_change_url}.js`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
							body: JSON.stringify({ line: lineIndex + 1, quantity })
						})
						.then(response => response.json());

				})
				.then(data=>{
					if ( data.status ) throw data;
					if ( data.alreadyRemoved ) return;
					return this.refreshCartFragments();
				})
				.then(()=>{
					this.notify();
				});
		},

		refreshCartFragments(){
			return fetch('?section_id=helper-cart')
				.then(response => response.text())
				.then(text=>{

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');

					const cartItems = document.getElementById('AjaxCartForm');
					const sectionCartItems = sectionInnerHTML.getElementById('AjaxCartForm');
					if ( cartItems && sectionCartItems ) {
						cartItems.innerHTML = sectionCartItems.innerHTML;
						if ( typeof cartItems.ajaxifyCartItems === 'function' ) {
							cartItems.ajaxifyCartItems();
						}
					}

					const cartSubtotal = document.getElementById('AjaxCartSubtotal');
					const sectionCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
					if ( cartSubtotal && sectionCartSubtotal ) {
						cartSubtotal.innerHTML = sectionCartSubtotal.innerHTML;
					}

					const cartCount = sectionInnerHTML.querySelector('[data-cart-count]');
					const cartTotal = sectionInnerHTML.querySelector('[data-cart-total]');
					if ( cartCount ) {
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = cartCount.textContent;
						});
					}
					if ( cartTotal ) {
						document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
							elm.textContent = cartTotal.textContent;
						});
					}

					/* redrawing the sticky bar is cosmetic, so keep any failure out of the add to cart
						 promise chain — otherwise a display error surfaces as a failed add that did succeed */
					document.querySelectorAll('sticky-cart-bar').forEach(elm=>{
						if ( typeof elm.refresh === 'function' ) {
							try {
								elm.refresh();
							} catch(error) {
								console.error('sticky-cart-bar refresh failed', error);
							}
						}
					});

				});
		},

		showError(container, error){
			if ( container.querySelector('.alert') ) {
				container.querySelector('.alert').remove();
			}
			const alert = document.createElement('span');
			alert.className = 'alert alert--error text-size--xsmall';
			alert.textContent = ( error && typeof error.description === 'string' ) ? error.description : ( error && error.message ) ? error.message : KROWN.settings.locales.cart_general_error;
			container.appendChild(alert);
			setTimeout(()=>{
				alert.remove();
			}, 4000);
		}

	};

}

if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){

			this.holder = this.querySelector('.quick-add-to-cart-button');
			this.addButton = this.querySelector('[data-js-product-add-to-cart]');
			this.qtyHolder = this.querySelector('[data-js-quick-buy-qty]');
			this.variantInput = this.querySelector('input[name="id"]');

			/* only the product card uses the inline quantity, the compact related/recommendation rows and the
				 gift wrapping helper (its checkbox clicks the add button programmatically) stay a plain add to cart */
			this.hasQuantity = !! ( this.holder && this.addButton && this.qtyHolder && this.variantInput && this.closest('.product-item__quick-buy') );

			if ( this.hasQuantity ) {
				this.initQuantity();
			} else if ( this.qtyHolder ) {
				this.qtyHolder.remove();
			}

			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( this.hasQuantity ) return;
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}
			});
		}

		/* add / quantity switch, same inner working as the quick buy popup */
		initQuantity(){

			const qtyInput = this.qtyHolder.querySelector('.qty-selector');
			const qtyMinus = this.qtyHolder.querySelector('.qty-minus');
			const qtyPlus = this.qtyHolder.querySelector('.qty-plus');

			/* handle the add ourselves so the flow stays inline instead of submitting the form / opening the cart */
			this.addButton.addEventListener('click', e=>{
				e.preventDefault();
				if ( this.addButton.classList.contains('working') ) return;
				this.addButton.classList.add('working');
				KROWN_QUICK_BUY.addVariant(this.variantInput.value, 1)
					.then(()=>{
						this.showQty(1);
					})
					.catch(error=>{
						KROWN_QUICK_BUY.showError(this, error);
					})
					.finally(()=>{
						this.addButton.classList.remove('working');
					});
			});

			[qtyMinus, qtyPlus].forEach(button=>{
				if ( ! button ) return;
				button.addEventListener('click', ()=>{
					setTimeout(()=>{
						if ( this.qtyHolder.classList.contains('working') ) return;
						const newQty = parseInt(qtyInput.value);
						const previousQty = button === qtyMinus ? newQty + 1 : newQty - 1;
						this.qtyHolder.classList.add('working');
						KROWN_QUICK_BUY.changeVariant(this.variantInput.value, newQty)
							.then(()=>{
								if ( newQty <= 0 ) {
									this.showAdd();
								}
							})
							.catch(error=>{
								KROWN_QUICK_BUY.showError(this, error);
								this.showQty(previousQty);
							})
							.finally(()=>{
								this.qtyHolder.classList.remove('working');
							});
					}, 50);
				});
			});

			this.syncWithCart();
			document.addEventListener(KROWN_QUICK_BUY.CART_CHANGED_EVENT, ()=>{
				this.syncWithCart();
			});
			/* cart drawer / cart page changes (the event does not bubble, so listen in the capture phase) */
			document.addEventListener('cart-updated', ()=>{
				KROWN_QUICK_BUY.refresh();
				this.syncWithCart();
			}, true);

		}

		syncWithCart(){
			return KROWN_QUICK_BUY.getCart()
				.then(cart=>{
					const quantity = KROWN_QUICK_BUY.lineQuantity(cart, this.variantInput.value);
					quantity > 0 ? this.showQty(quantity) : this.showAdd();
				})
				.catch(()=>{});
		}

		showQty(quantity){
			const qtyInput = this.qtyHolder.querySelector('.qty-selector');
			const qtyMinus = this.qtyHolder.querySelector('.qty-minus');
			const qtyPlus = this.qtyHolder.querySelector('.qty-plus');
			qtyInput.value = quantity;
			qtyMinus.classList.remove('disabled');
			qtyPlus.classList.remove('disabled');
			this.qtyHolder.style.display = '';
			this.holder.classList.add('has-quantity');
			this.addButton.setAttribute('tabindex', '-1');
			this.addButton.setAttribute('aria-hidden', 'true');
		}

		showAdd(){
			this.qtyHolder.style.display = 'none';
			this.qtyHolder.querySelector('.qty-selector').value = 1;
			this.holder.classList.remove('has-quantity');
			this.addButton.removeAttribute('tabindex');
			this.addButton.removeAttribute('aria-hidden');
		}

	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

		initModalProduct(){

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( ! productVariants._defaultToFirstVariant ) {
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
					this.quickViewModal.querySelector('product-page').onVariantChangeHandler({target:productVariants});
				}
			}

		}

		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}
			})
			this.querySelector('a').addEventListener('click', e=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							});

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);
							
						});

				} else {
					this.quickViewModal.show();
				}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}

/* ---
	Quick Buy Modal (variant list popup)
--- */

if ( typeof QuickBuyModal !== 'function' ) {

	class QuickBuyModal extends HTMLElement {

		constructor(){
			super();
			this.modal = null;
			this.trigger = this.querySelector('[data-js-quick-buy-trigger]');
			this.template = this.querySelector('[data-js-quick-buy-template]');
			this.trigger.addEventListener('click', e=>{
				e.preventDefault();
				this.open();
			});
		}

		open(){

			if ( ! this.modal ) {

				this.trigger.classList.add('working');

				const container = document.createElement('div');
				container.innerHTML = `<modal-box id="quick-buy-modal-${this.dataset.productId}"
					class="modal modal--product modal--quick-buy"
					data-options='{
						"enabled": false,
						"showOnce": false,
						"blockTabNavigation": true
					}'
					tabindex="-1" role="dialog" aria-modal="true"
				>
					<div class="container--medium">
						<div class="modal-content"></div>
					</div>
					<span class="modal-background" data-js-close></span>
				</modal-box>`;

				this.modal = container.querySelector('modal-box');
				this.modal.querySelector('.modal-content').appendChild(this.template.content.cloneNode(true));
				document.body.appendChild(this.modal);

				this.modal.querySelectorAll('[data-js-close]').forEach(elm=>{
					elm.addEventListener('click', ()=>{
						this.modal.hide();
					});
				});

				this.initItems();

				this.syncWithCart().finally(()=>{
					this.trigger.classList.remove('working');
					this.modal.show();
				});

			} else {
				this.syncWithCart().finally(()=>{
					this.modal.show();
				});
			}

		}

		initItems(){
			this.modal.querySelectorAll('[data-js-quick-buy-item]').forEach(item=>{

				const variantId = item.dataset.variantId;
				const addButton = item.querySelector('[data-js-quick-buy-add]');
				const qtyHolder = item.querySelector('[data-js-quick-buy-qty]');
				const qtyInput = item.querySelector('.qty-selector');
				const qtyMinus = item.querySelector('.qty-minus');
				const qtyPlus = item.querySelector('.qty-plus');

				if ( ! addButton ) return;

				addButton.addEventListener('click', ()=>{
					if ( addButton.classList.contains('working') ) return;
					addButton.classList.add('working');
					this.addVariant(variantId, 1)
						.then(()=>{
							this.showQty(item, 1);
						})
						.catch(error=>{
							this.showError(item, error);
						})
						.finally(()=>{
							addButton.classList.remove('working');
						});
				});

				[qtyMinus, qtyPlus].forEach(button=>{
					button.addEventListener('click', ()=>{
						setTimeout(()=>{
							if ( qtyHolder.classList.contains('working') ) return;
							const newQty = parseInt(qtyInput.value);
							const previousQty = button === qtyMinus ? newQty + 1 : newQty - 1;
							qtyHolder.classList.add('working');
							this.changeVariant(variantId, newQty)
								.then(()=>{
									if ( newQty <= 0 ) {
										this.showAdd(item);
									}
								})
								.catch(error=>{
									this.showError(item, error);
									this.showQty(item, previousQty);
								})
								.finally(()=>{
									qtyHolder.classList.remove('working');
								});
						}, 50);
					});
				});

			});
		}

		showQty(item, quantity){
			const addButton = item.querySelector('[data-js-quick-buy-add]');
			const qtyHolder = item.querySelector('[data-js-quick-buy-qty]');
			const qtyInput = qtyHolder.querySelector('.qty-selector');
			const qtyMinus = qtyHolder.querySelector('.qty-minus');
			const qtyPlus = qtyHolder.querySelector('.qty-plus');
			qtyInput.value = quantity;
			qtyMinus.classList.remove('disabled');
			qtyPlus.classList.remove('disabled');
			addButton.style.display = 'none';
			qtyHolder.style.display = '';
		}

		showAdd(item){
			const addButton = item.querySelector('[data-js-quick-buy-add]');
			const qtyHolder = item.querySelector('[data-js-quick-buy-qty]');
			qtyHolder.style.display = 'none';
			qtyHolder.querySelector('.qty-selector').value = 1;
			addButton.style.display = '';
		}

		showError(item, error){
			KROWN_QUICK_BUY.showError(item, error);
		}

		syncWithCart(){
			return KROWN_QUICK_BUY.refresh()
				.then(cart=>{
					this.modal.querySelectorAll('[data-js-quick-buy-item]').forEach(item=>{
						const quantity = KROWN_QUICK_BUY.lineQuantity(cart, item.dataset.variantId);
						quantity > 0 ? this.showQty(item, quantity) : this.showAdd(item);
					});
				})
				.catch(()=>{});
		}

		addVariant(variantId, quantity){
			return KROWN_QUICK_BUY.addVariant(variantId, quantity);
		}

		changeVariant(variantId, quantity){
			return KROWN_QUICK_BUY.changeVariant(variantId, quantity);
		}

	}

  if ( typeof customElements.get('quick-buy-modal') == 'undefined' ) {
		customElements.define('quick-buy-modal', QuickBuyModal);
	}

}